import React from 'react';
import PropTypes from 'prop-types';
/* components */
import Input from '../input/input';
import Validation from '../validation/validation';

export class EditableList extends React.PureComponent {
    handleItemChange = (index) => (value) => {
        const list = [...this.props.value];
        list[index] = value;
        this.props.onChange(list);
    };

    handleItemAdd = () => {
        this.props.onChange([...this.props.value, '']);
    };

    handleItemRemove = (index) => () => {
        const list = [...this.props.value];
        list.splice(index, 1);
        this.props.onChange(list);
    };

    getLabelText = (label, hideOrdinals, index) => (
        `${label ? `${label} ` : ''}${hideOrdinals ? '' : index + 1}`
    );

    render() {
        const { addBtnLabel, label, labelInline, hideOrdinals, name, placeholder, validations, value } = this.props;
        return (
            <React.Fragment>
                {value && value.map((item, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <div className="form-row" key={index}>
                        {!labelInline && (label || !hideOrdinals) && (
                            <label className="label">{this.getLabelText(label, hideOrdinals, index)}</label>
                        )}
                        <div className="flex-row flex-center">
                            {labelInline && (label || !hideOrdinals) && (
                                <div className="flex-shrink">
                                    <label className="label">{this.getLabelText(label, hideOrdinals, index)}</label>
                                </div>
                            )}
                            <div className="flex-grow">
                                {validations
                                    ? (
                                        <Validation.Wrapper validations={validations} hintsOnHover>
                                            <Input
                                                name={`${name}[${index}]`}
                                                placeholder={placeholder}
                                                value={item}
                                                onChange={this.handleItemChange(index)}
                                            />
                                        </Validation.Wrapper>
                                    ) : (
                                        <Input
                                            name={`${name}[${index}]`}
                                            placeholder={placeholder}
                                            value={item}
                                            onChange={this.handleItemChange(index)}
                                        />
                                    )
                                }
                            </div>
                            <div className="flex-shrink">
                                <button
                                    type="button"
                                    className="btn-link btn__icon icon icon-delete"
                                    onClick={this.handleItemRemove(index)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
                <div className="form-row">
                    <button
                        type="button"
                        className="btn-link btn-link--inverted text-uppercase"
                        onClick={this.handleItemAdd}
                    >
                        <span className="btn__icon icon icon-plus" />
                        {addBtnLabel}
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

EditableList.propTypes = {
    addBtnLabel: PropTypes.string,
    label: PropTypes.string,
    labelInline: PropTypes.bool,
    hideOrdinals: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    validations: PropTypes.objectOf(PropTypes.any),
    value: PropTypes.arrayOf(PropTypes.string).isRequired
};

EditableList.defaultProps = {
    addBtnLabel: '',
    label: '',
    labelInline: false,
    hideOrdinals: false,
    name: '',
    placeholder: '',
    validations: null
};

export default EditableList;
